var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"compliances py-2"},_vm._l((_vm.compliances),function(compliance){return _c('Chip',{key:compliance.id,staticClass:"mx-1 my-1",attrs:{"color":_vm.color}},[_c('v-icon',{staticClass:"mr-1"},[_vm._v(_vm._s(_vm.icon))]),_vm._v(" "+_vm._s(compliance.complianceCheckName)+" ")],1)}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }